module.exports = __webpack_public_path__ + "img/complete.891b9c27.svg";